module.exports = __webpack_public_path__ + "static/media/IMG_018.afb70b6c.JPG";